import type { ApiError } from '../@types';

export const getFreeSpinBetErrorMessage = (error: ApiError): string | undefined => {
  const message = error?.response?.data?.message;
  if (typeof message === 'string' && /\bBet \S+ is not allowed for this game\./.test(message)) return message;
};
